// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import 'vuetify/styles'
import * as components from 'vuetify/components'
import { fa } from 'vuetify/iconsets/fa-svg'
import { de, en, fr, it } from 'vuetify/locale'
import { config } from '@deepcloud/deep-ui-lib'
import i18n from '@/plugins/i18n'

export default config.createVuetifyConfig({
  components: {
    ...components,
  },
  locale: {
    messages: {
      de,
      en,
      fr,
      it,
    },
    locale: i18n.global.locale.value,
  },
  icons: {
    sets: {
      fa,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          'primary': '#212121',
          'secondary': '#de323c',
          'tertiary': '#1967bf',
          'surface-light': '#f3f4f6',
          'warning': '#f57c00',
          'info': '#1B76D2',
          'secondary-10': '#2c0709',
          'secondary-20': '#580e12',
          'secondary-30': '#84151c',
          'secondary-40': '#b01c25',
          'secondary-50': '#de323c',
          'secondary-60': '#e34f58',
          'secondary-70': '#ea7b82',
          'secondary-80': '#f1a7ab',
          'secondary-90': '#f8d3d5',
        },
      },
    },
  },
  aliases: {
    VBtnToolbar: components.VBtn,
    VBtnSecondaryIcon: components.VBtn,
  },
  defaults: {
    VIcon: {
      size: 16,
    },
    VBtnPrimary: {
      color: 'secondary',
      VIcon: {
        size: 12,
      },
    },
    VBtnSecondary: {
      VIcon: {
        size: 12,
      },
    },
    VBtnSecondaryIcon: {
      variant: 'outlined',
      class: 'rounded',
      width: '36',
      height: '36',
      tile: true,
      VIcon: {
        size: 12,
      },
    },
    VBtnToolbar: {
      variant: 'text',
      size: 'small',
      VIcon: {
        size: 'x-small',
      },
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'compact',
    },
    VCombobox: {
      variant: 'outlined',
      density: 'compact',
    },
    VSelect: {
      variant: 'outlined',
      density: 'compact',
    },
    VProgressCircular: {
      indeterminate: true,
      width: 2,
    },
    VTextField: {
      variant: 'outlined',
      density: 'compact',
    },
    VTextarea: {
      variant: 'outlined',
    },
    VNumberInput: {
      variant: 'outlined',
      density: 'compact',
    },
    VChip: {
      class: 'font-weight-medium px-2',
      rounded: 'md',
      density: 'comfortable',
      size: 'small',
      VIcon: {
        size: 12,
        class: 'mr-1 ml-0',
      },
    },
    VAlert: {
      variant: 'tonal',
      density: 'compact',
      class: 'text-body-medium',
    },
    VTabs: {
      color: 'secondary',
      density: 'compact',
      showArrows: true,
      class: 'border-b',
      style: '--v-border-opacity: 0.08',
    },
    VTab: {
      ripple: false,
      class: 'px-3',
    },
    VTabsWindow: {
      transitionDuration: 200,
    },
    VMenu: {
      transition: 'fade-transition',
    },
    VDataTableServer: {
      itemsPerPageOptions: [
        { value: 10, title: '10' },
        { value: 25, title: '25' },
        { value: 50, title: '50' },
        { value: 100, title: '100' },
      ],
    },
    VCheckbox: {
      density: 'compact',
      VLabel: {
        class: 'text-body-medium',
      },
    },
    VSwitch: {
      color: 'secondary',
      density: 'compact',
      size: 'small',
      flat: false,
      hideDetails: 'auto',
      VLabel: {
        class: 'text-body-medium',
      },
    },
    VRadioGroup: {
      density: 'comfortable',
    },
    VRadio: {
      VLabel: {
        class: 'text-body-medium',
      },
    },
  },
})
